<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>

    <div id="main-panel" class="main main-raised" ref="page">
      <div class="cd-section section section-basic">
        <div class="md-layout" v-if="loaded">
          <div
            class="md-layout md-layout-item md-size-65 md-small-size-90 mx-auto"
            style="margin-bottom:0px"
          >
            <details-card :item="model" />

            <div
              v-if="model.panels.length"
              style="margin:25px 0px"
              class="md-layout-item md-size-100"
            >
              <h3 class="bold text-primary" style="margin-bottom:5px">{{$t('Participates in')}}</h3>
              <hr class="text-primary" style="margin:30px 0px" />
              <div v-for="r in distinctRoles" :key="r">
                <panel-item
                  v-for="p in getPanelsByRole(r)"
                  :key="p.panel.id"
                  :item="p.panel"
                  :showDate="true"
                  :showDetailsLink="true"
                />
              </div>
            </div>

            <div class="md-layout md-layout-item md-size-100">
              <div class="ml-auto">
                <md-button
                  @click.prevent="$router.go(-1)"
                  class="md-round md-primary md-sm md-blue-border"
                  style="margin:0px"
                >{{$t('Go back')}}</md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions } from "vuex";
import axios from "@/util/axios";
import PanelItem from "./components/Agenda/PanelListItem.vue";
import PageHeader from "./layout/PageHeader";
import DetailsCard from "./components/Attendees/AttendeesListItem";

export default {
  components: { PanelItem, PageHeader, DetailsCard },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current",
      hasChatAccess: "user/hasChatAccess"
    }),
    distinctRoles: function() {
      let roles = [
        ...new Map(
          this.model.panels.map(item => [item.role, item.role])
        ).values()
      ];

      let order = [1, 7, 6, 4, 5, 2, 3];
      order = [2, 7, 6, 1, 5, 3, 4];
      return roles.sort((a, b) => order[a] - order[b]);
    },
    avatarUrl() {
      return axios.getAttendeeAvatarUrl(
        this.conference.year,
        this.conference.type,
        this.model.externalId
      );
    }
  },
  props: ["id"],
  data() {
    return {
      loaded: false,
      model: { description: {}, panels: [] },
      image: require("@/assets/img/conference/landing-bg-fe26.jpg") // header img
    };
  },
  methods: {
    async loadData() {
      let loader = this.$loading.show({ container: this.$refs.page });
            try {
        this.model = (
          await axios.get("public/attendees/details", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code,
              id: this.id
            }
          })
        ).data;
      } finally {
        this.loaded = true;
        loader.hide();
      }
    },
    getPanelsByRole(role) {
      return this.model.panels
        .filter(e => e.role === role)
        .sort(
          (a, b) =>
            a.startDate < b.startDate ||
            (a.startDate == b.startDate && a.endDate < b.endDate)
        );
    },
    imgNotLoaded(event) {
      if (!this.imgLoaded) {
        event.target.src = require("@/assets/img/blank_avatar.png");
      }
      this.imgLoaded = true;
    },
    async openChat() {
      let loader = this.$loading.show();

      try {
        var details = (
          await axios.get("/chat/users/details", {
            params: {
              conferenceYear: this.conference.year,
              conferenceType: this.conference.type,
              externalId: this.model.externalId
            }
          })
        ).data;

        if (details.canHeChat) {
          this.$router.push({ name: "chat", params: { id: details.userId } });
        } else {
          this.$swal({
            icon: "info",
            title: self.$t("Info"),
            text: self.$t("Chat inactive for the selected user")
          });
        }
      } finally {
        loader.hide();
      }
    }
  },
  async mounted() {
    await this.loadData();
  },
  watch: {
    async id() {
      this.model = { description: {}, panels: [] };
      await this.loadData();
    },
    async language() {
      this.model = { description: {}, panels: [] };
      await this.loadData();
    }
  }
};
</script>


<style lang="scss" scoped>
h1.info-title {
  font-size: 5rem;
}
.info-title {
  color: white !important;
}

.info-title > hr {
  color: white;
}

.page-header .container {
  max-width: 70% !important;
}

.md-button.md-just-icon {
  height: 22px;
  min-width: 0px;
  width: 24px;
  padding: 0px;
  margin: 0px;

  margin-bottom: 5px;
  overflow: hidden;
  position: relative;
}

.md-button .md-ripple {
  padding: 0px !important;
  display: inline-block;
  justify-content: center;
  align-items: center;

  .md-icon {
    padding: 0px !important;
  }
}

.md-card {
  margin: 10px 0px;
  padding: 10px;
  box-shadow: 0px 0px 30px #0000001a;
  border-radius: 30px;
  opacity: 1;
}
</style>
